import { useEffect, useRef } from "react";
import { addReaction } from "../../../../services/chats/frontend-chats";
import { GetAuthUserLocalStorage } from "../../../../services/localStorage/localStorage";
import { useDispatch } from "react-redux";
import { REACTION_ORDER } from "../../../../utils/reactions";

const ReactionPicker = ({ visible, onClose, message, chatId }) => {
  const dispatch = useDispatch();
  const authUser = GetAuthUserLocalStorage();
  const pickerRef = useRef(null);

  const handleReactionSelect = async (emoji) => {
    if (!message || !chatId || !authUser?.id) return;

    try {
      await addReaction(
        message.thread_id,
        chatId,
        emoji,
        authUser.id,
        dispatch,
        message,
      );
      onClose();
    } catch (error) {
      console.error("Error adding reaction:", error);
    }
  };

  // Click outside handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (visible) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [visible, onClose]);

  if (!visible || !message) return null;

  return (
    <div
      ref={pickerRef}
      className="reaction-picker-floating"
      style={{
        position: "absolute",
        top: "0px",
        right: "5px",
        zIndex: 10000,
      }}
    >
      <div className="reaction-picker-content">
        <div className="reaction-options">
          {REACTION_ORDER.map((emoji) => (
            <div
              key={emoji}
              className="reaction-option"
              onClick={() => handleReactionSelect(emoji)}
            >
              <span className="reaction-emoji">{emoji}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReactionPicker;
